import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FingerprintOutlined } from '@material-ui/icons';

import {
  AUTENTIA_ERROR,
  AUTENTIA_INITIALIZING,
  AUTENTIA_MISSING_RUT,
  AUTENTIA_BUTTON_LABEL
} from '../../libraries/texts';
import {
  AUTENTIA_ERROR_CODES,
  FINGER_ERROR_STATUS_CODE,
  FINGER_WARNING_STATUS_CODE,
  FINGER_SUCCESSFULL_STATUS_CODE,
  FINGER_RUNNING_STATUS_CODE,
  FINGER_DISABLED_STATUS_CODE,
  FINGER_NORMAL_STATUS_CODE
} from '../../libraries/constants';
import FootPrintService from '../../services/footprint-service';

export const getFingerPrintField = props => {
  const {
    classes,
    extraClasses = '',
    errors,
    touched,
    prefix,
    values,
    name = 'finger',
    setFieldValue
  } = props;
  const messageField = `${prefix}Message`;
  const fingerStatus = `${prefix}Status`;
  const hasFingerPrint = `${prefix}CapturedFingerprint`;
  const otherFingerStatus = `${prefix === 'suscriptor' ? 'aval' : 'suscriptor'}Status`;
  const olderOtherFingerStatus = values[otherFingerStatus];
  const contributionField = `${prefix}Contributions`;
  const OpenFingerInterface = async () => {
    setFieldValue('avalDniDisabled', true);
    setFieldValue(`suscriptorDniDisabled`, true);
    setFieldValue(fingerStatus, FINGER_RUNNING_STATUS_CODE);
    setFieldValue(otherFingerStatus, FINGER_DISABLED_STATUS_CODE);
    const rut =
      values[`${prefix}Dni`] && values[`${prefix}DniNumber`]
        ? `${values[`${prefix}Dni`]}-${values[`${prefix}DniNumber`]}`
        : '';

    const getLoginData = async val => {
      setFieldValue(contributionField, []);
      setFieldValue(fingerStatus, FINGER_RUNNING_STATUS_CODE);
      
      const { ercText, LoginResult } = val;
      if (ercText.includes('Error')) {
        setFieldValue(hasFingerPrint, true);
        setFieldValue('avalDniDisabled', false);
        setFieldValue(`suscriptorDniDisabled`, false);
        setFieldValue(messageField, AUTENTIA_ERROR);
        setFieldValue(fingerStatus, FINGER_WARNING_STATUS_CODE);
        setFieldValue(otherFingerStatus, olderOtherFingerStatus);
        return;
      }
      if (LoginResult === 0) {
        setFieldValue(messageField, AUTENTIA_INITIALIZING);
      }
      await FootPrintService.verify(rut, getVerifyData);
    };
    const getVerifyData = async val => {
      setFieldValue(fingerStatus, FINGER_RUNNING_STATUS_CODE);
      const { Erc, ErcDesc, NroAudit, erc, ercText } = val;
      console.log('Autentia', Erc, erc, ErcDesc, ercText);
      setFieldValue(messageField, ErcDesc);
      
      if (AUTENTIA_ERROR_CODES.includes(Erc) || !NroAudit) {
        console.log('Erc', Erc);
        setFieldValue(hasFingerPrint, true);
        setFieldValue('avalDniDisabled', false);
        setFieldValue(`suscriptorDniDisabled`, false);
        setFieldValue(fingerStatus, FINGER_ERROR_STATUS_CODE);
        setFieldValue(otherFingerStatus, olderOtherFingerStatus);
        await FootPrintService.logout();
        return;
      }

      try {
        console.log('FINGER_RUNNING_STATUS_CODE', FINGER_RUNNING_STATUS_CODE);
        setFieldValue(fingerStatus, FINGER_RUNNING_STATUS_CODE);
        const response = await FootPrintService.getContributions(rut, NroAudit);
        const { contributions } = response;
        setFieldValue(fingerStatus, FINGER_SUCCESSFULL_STATUS_CODE);
        setFieldValue(otherFingerStatus, olderOtherFingerStatus);
        setFieldValue(contributionField, contributions);
        setFieldValue(messageField, '');
        setFieldValue(hasFingerPrint, true);
        setFieldValue('avalDniDisabled', false);
        setFieldValue(`suscriptorDniDisabled`, false);
      } catch (err) {
        setFieldValue(hasFingerPrint, true);
        setFieldValue(fingerStatus, FINGER_WARNING_STATUS_CODE);
        setFieldValue(otherFingerStatus, olderOtherFingerStatus);
        setFieldValue('avalDniDisabled', false);
        setFieldValue(`suscriptorDniDisabled`, false);
        console.log(JSON.stringify(err));
        const { errors } = err;
        setFieldValue(messageField, errors.join(','));
        setFieldValue(contributionField, []);
        await FootPrintService.logout();
      }
      await FootPrintService.logout();
    };

    if (!rut) {
      setFieldValue(fingerStatus, FINGER_ERROR_STATUS_CODE);
      setFieldValue(otherFingerStatus, olderOtherFingerStatus);
      setFieldValue(messageField, AUTENTIA_MISSING_RUT);
      return;
    }
    await FootPrintService.login(values.rut, getLoginData);
    setFieldValue(hasFingerPrint, true);
  };

  return (
    <FormControl
      required
      className={classNames(classes.middleWidth, classes.marginBottom, extraClasses, {
        [classes.error]: errors[name] && touched[name],
        [classes.fingerErrorContainter]: FINGER_ERROR_STATUS_CODE === values[fingerStatus],
        [classes.fingerWarningContainer]: FINGER_WARNING_STATUS_CODE === values[fingerStatus],
        [classes.fingerOkContainer]: FINGER_SUCCESSFULL_STATUS_CODE === values[fingerStatus],
        [classes.fingerRunningContainter]: FINGER_RUNNING_STATUS_CODE === values[fingerStatus],
        [classes.fingerDisabledContainer]: FINGER_DISABLED_STATUS_CODE === values[fingerStatus]
      })}
    >
      <Tooltip
        title={values[messageField]}
        disableFocusListener
        placement="top"
        className={classNames(classes.fingerTooltip)}
      >
        <div className={classes.fingerContainer}>
          <div>
            <CircularProgress
              className={classNames(
                classes.progress,
                classes.positionAbsolute,
                classes.fingerStopLoading
              )}
            />
          </div>
          <FingerprintOutlined className={classNames(classes.positionAbsolute)} />

          <Button
            disabled={
              ![
                FINGER_NORMAL_STATUS_CODE,
                FINGER_WARNING_STATUS_CODE,
                FINGER_ERROR_STATUS_CODE
              ].includes(values[fingerStatus])
            }
            variant="outlined"
            size="small"
            color="primary"
            className={classNames(classes.margin, classes.positionAbsolute)}
            onClick={OpenFingerInterface}
          >
            {AUTENTIA_BUTTON_LABEL}
          </Button>
        </div>
      </Tooltip>
    </FormControl>
  );
};
